import { Timestamp } from 'firebase/firestore';
import { parseISO, format as formatDate, isValid as isValidDate } from 'date-fns';

export const toISODate = (value) => {
  if (!value) return '';

  // Firestore Timestamp
  if (value instanceof Timestamp) return value.toDate().toISOString().slice(0, 10);

  // JS Date
  if (value instanceof Date) return value.toISOString().slice(0, 10);

  // Already a string → keep as-is
  return value;          // assumes it’s something like "1970-05-01"
};


// Returns true when `value` is a valid date AND
//   – earlier than today, and
//   – no more than 120 years ago.
export const isValidDateOfBirth = (value) => {
  // Try to build a Date object. (Accepts Date instances or parseable strings)
  const dob = value instanceof Date ? value : new Date(value);

  // Reject anything the Date constructor couldn’t parse
  if (Number.isNaN(dob.getTime())) return false;

  const today = new Date();               // “now”
  const oldestAllowed = new Date();       // today − 120 years
  oldestAllowed.setFullYear(today.getFullYear() - 120);

  // Must be BEFORE today, and AFTER (or on) the oldest allowed date
    return dob < today && dob >= oldestAllowed;
  };
  
  // Helper to convert YYYY-MM-DD string or Firestore Timestamp to Date object
  export const parseDate = (dateValue) => {
      if (!dateValue) return null;
  
      // Handle Firestore Timestamp object
      if (typeof dateValue.toDate === 'function') {
          return dateValue.toDate();
      }
  
      // Handle JS Date object
      if (dateValue instanceof Date) {
          return dateValue;
      }
  
      // Handle ISO date string
      if (typeof dateValue === 'string') {
          const parsed = parseISO(dateValue);
          return isValidDate(parsed) ? parsed : null;
      }
  
      return null; // Return null for other invalid types
  };

    // Helper to convert YYYY-MM-DD string to Date object or null
    export const stringToDate = (dateString) => {
        if (!dateString) return null;
        const parsed = parseISO(dateString);
        return isValidDate(parsed) ? parsed : null;
    };

    // Helper to format Date object to YYYY-MM-DD string
    export const dateToString = (dateObject) => {
        if (!dateObject || !isValidDate(dateObject)) return '';
        return formatDate(dateObject, 'yyyy-MM-dd');
    };